import './ColumnLayout.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps extends PropsWithChildren {
  size: 'none' | 'sm' | 'md' | 'l';
  className?: string;
}

export const ColumnLayout = ({ children, className, size }: IProps): ReactElement => (
  <div className={classNames('column-layout', className, size)}>{children}</div>
);
